export const PALLETE = [
  0xedae49,
  0xd1495b,
  0x00798c,
  0x30638e,
  0x003d5b,
  0x4b3f72,
  0xe9190f,
  0xf75c03,
  0xf1c40f,
  0xfe5f55,
]

export const isMobile = () => {
  return window.innerWidth < 1024
}
